export class RbsData {
  constructor(data) {
    this.lastName = data.lastName;
    this.serverId = data.serverId;
    this.userId = data.userId;
  }
}
